export class HomeController {
    constructor($scope, $http, $modal, $route, $rootScope, $sce, AuthService, UserService, BannerService, PaymentService) {
        $scope.vm = this;
        $scope.users = [];
        $scope.banner = {};
        this.modal = $modal;
        this.scope = $scope;
        this.route = $route;
        this.rootScope = $rootScope;
        this.http = $http;
        this.sce = $sce;
        this.AuthService = AuthService;
        this.UserService = UserService;
        this.BannerService = BannerService;
        this.PaymentService = PaymentService;

        this.init();
    }

    init() {
      this.scope.currentPage = 1;
      this.scope.limit = 12;
      this.scope.pageCount = 0;
      this.scope.totalCount = 0;

      this.scope.getUsers = (page) => {
        this.UserService.getDailyUsers(this.rootScope.currentUserProfile._id, this.scope.currentPage, this.scope.limit)
        .then((response) => { let data = response.data;
          this.scope.pageCount = data.pageCount;
          this.scope.totalCount = data.totalCount;
          this.scope.users = data.users;
          this.scope.userListLoading = false;
        })
        .catch((response) => { let err = response.data;
          console.log("Cannot get users  ", err);
          this.scope.userListLoading = false;
        });
      }

      this.UserService.getCurrentUser()
        .then((response) => { let user = response.data;
          this.rootScope.currentUserProfile = user.data;
          this.scope.userListLoading = true;
          this.scope.getUsers(1);
        })
        .catch((response) => { let err = response.data;
          console.error(err);
        });


      this.scope.decPage = () => {
        this.scope.currentPage--;
      };

      this.scope.incPage = () => {
        this.scope.currentPage++;
      };
    }
}
